<template>
  <div class="app-cancel-tariff-modal-wrapper">
    <TariffChangeBookingModal
      :show.sync = show
      :content = modalContent
      :actions = "createActions()"
      @click:cancelTariff="cancelTariff(bookedTariff)"
    >
      <template v-for="slot in possibleChildSlotsFor('Modal', bookedTariff.tariffId)" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </TariffChangeBookingModal>
  </div>
</template>
<script>

import slotProxy from '@/mixins/slotProxy'
import { mapActions, mapGetters } from 'vuex'
import TariffChangeBookingModal from '@/components/process/generic/Tariff/generic/TariffChangeBookingModal.vue'
import { durationUnit } from '@/mixins/durationUnit'

export default {
  name: 'CancelTariffModalWrapper',
  mixins: [
    slotProxy()
  ],
  components: { TariffChangeBookingModal },
  data () {
    return {
      show: false,
      bookedTariff: [],
      contractUrl: '',
      notification: []
    }
  },
  computed: {
    modalContent: function () {
      return {
        title: this.bookedTariff.name,
        detailBoxes: this.createDetails(this.bookedTariff),
        slotData: this.createSlotData(this.bookedTariff),
        documentUrl: this.contractUrl ? this.contractUrl : null,
        theme: this.bookedTariff.tariffId,
        messageBox: this.notification
      }
    },
    slotData () {
      return this.content.slotData
    },
    ...mapGetters([
      'accessToken'
    ])
  },
  methods: {
    showCancelModal (responseInformation, bookedTariffId, bookedTariff) {
      const baseUrl = this.$config.apiUrl
      if (responseInformation.contractUrl) {
        this.contractUrl = baseUrl + '' + responseInformation.contractUrl
      }
      this.show = true
      this.bookedTariff = bookedTariff
      this.notification = responseInformation.notification
    },
    createDetails (option) {
      return [
        ...option.tariffExtra?.volumes || [],
        {
          primary: option.formattedBasicFee,
          secondary: option.runtime?.amount === 0 ? null : '/' + option.runtime?.amount + ' ' + durationUnit(option.runtime?.unit.toUpperCase(), option.runtime?.amount)
        }]
    },
    createSlotData (tariff) {
      return {
        name: tariff.name,
        formattedBasicFee: tariff.formattedBasicFee,
        cancelDate: tariff.possibleChangingDate,
        formattedUnit: tariff.formattedUnit,
        amount: tariff.runtime?.amount
      }
    },
    formatDate (date) {
      if (date) {
        return this.$config.calendar.formatter.dateFormatter.format(new Date(date))
      }
      return null
    },
    createMessageType () {
      return 'Cancelable'
    },
    ...mapActions('bookTariff', [
      'confirmCancelTariff'
    ]),
    cancelTariff (bookedTariff) {
      const me = this
      this.confirmCancelTariff({
        tariffToCancel: bookedTariff.tariffId,
        process: 'cancelTariff'
      }).then((response) => {
        if (response) {
          me.$store.commit('addMessage', { type: 'success', message: 'Tarif erfolgreich gekündigt' })
          me.$emit('refresh')
        }
        this.show = false
      }, () => {
        this.show = false
      })
    },
    createActions () {
      return [
        {
          type: 'cancelTariff',
          text: 'Tarif kündigen'
        }
      ]
    }
  },
  props: {
    content: {
      type: Object,
      default: () => {}
    },
    actions: {
      type: Array,
      default: () => []
    }
  }
}

</script>
